import { ConsentOrdersPathName, FormNavigation, FurnitureProps_1 } from "@fla/components";
import FurnitureIcon from "@fla/components/src/assets/svgs/furniture.svg";
import { useAppDispatch } from "app/store";
import { withConsentOrder } from "components/HOCs/withConsentOrder";
import { useConsentOrders } from "hooks/ConsentOrders";
import { SliceStatus } from "interfaces";
import { consentOrdersActions, selectBaseAssetsDebts } from "pages/ConsentOrders";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { formSteps } from "./steps";

const defaultValues = {
  if_furniture_or_personal_effects: "",
  category: "",
  description: "",
  user_value: "",
  spouse_value: ""
};

function FurnitureAndPersonal() {
  const assetsDebts = useSelector(selectBaseAssetsDebts);
  const [status, setStatus] = useState(SliceStatus.Idle);

  const [currentStep, setCurrentStep] = useState(1);
  const [formState, setFormState] = useState(
    useMemo(() => {
      if (assetsDebts?.furniture) {
        return assetsDebts?.furniture.data;
      } else {
        return defaultValues;
      }
    }, [assetsDebts])
  );

  const CurrentTab = formSteps[currentStep as keyof typeof formSteps];

  const isLastStep = () => currentStep === Object.keys(formSteps).length;
  const isFirstStep = () => currentStep === 1;

  const isLast = isLastStep();
  const isFirst = isFirstStep();

  const location = useLocation();
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate(ConsentOrdersPathName.Overseas);
  };

  const dispatch = useAppDispatch();
  const { updateAssetsDebts } = useConsentOrders();

  const onSubmit = async (formData: FurnitureProps_1) => {
    setFormState(prevState => ({ ...prevState, ...formData }));

    if (!isLast) setCurrentStep(prev => prev + 1);
    else {
      try {
        setStatus(SliceStatus.Pending);
        const payload = {
          furniture: { data: formData, isCompleted: true },
          currentStep: 9
        };
        await updateAssetsDebts(payload);
        dispatch(consentOrdersActions.setAssetsDebts(payload));
        navigate(ConsentOrdersPathName.Debts);

        setStatus(SliceStatus.Resolved);
      } catch (error) {
        setStatus(SliceStatus.Rejected);
      }
    }
  };

  useEffect(() => {
    if (location.state) {
      setFormState(location.state);
    } else {
      setFormState(assetsDebts?.furniture?.data);
    }
  }, [location]);

  return (
    <section className="w-full py-10">
      <div className="md:w-10/12 lg:max-w-2xl mx-auto h-fit px-5 md:px-10 md:py-5 space-y-5">
        <img src={FurnitureIcon} className="w-10 h-auto mx-auto my-3" alt="Furniture & personal effects" />

        <h3 className="text-center my-5">Furniture & personal effects</h3>

        <CurrentTab formId="furniture-form" store={formState} onSubmit={onSubmit} />
        <FormNavigation
          isFirst={isFirst}
          isLast={false}
          form="furniture-form"
          handleBackClick={handleBackClick}
          isSubmitting={status === SliceStatus.Pending}
          classes="mt-12"
          nextButtonText="Continue"
        />
      </div>
    </section>
  );
}
export default withConsentOrder(FurnitureAndPersonal);
